import React from "react";
import { t } from "../i18n";

function scoreTone(score) {
  if (score >= 85) return { bg: "bg-emerald-50", border: "border-emerald-600", fg: "text-emerald-700", label: "A" };
  if (score >= 70) return { bg: "bg-amber-50", border: "border-amber-600", fg: "text-amber-700", label: "B" };
  if (score >= 50) return { bg: "bg-orange-50", border: "border-orange-600", fg: "text-orange-700", label: "C" };
  return { bg: "bg-red-50", border: "border-red-600", fg: "text-red-700", label: "D" };
}

export default function ScoreGauge({ score = 0, stats = {}, lang }) {
  const tone = scoreTone(score);
  return (
    <div
      className={`border ${tone.border} ${tone.bg} p-6 ma-in`}
      data-testid="compliance-score-card"
    >
      <div className="flex items-start justify-between gap-8 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] font-mono text-neutral-600">
            {t(lang, "score")}
          </div>
          <div className="flex items-baseline gap-3 mt-2">
            <span
              className={`font-display font-bold text-6xl md:text-7xl ${tone.fg} leading-none`}
              data-testid="compliance-score-value"
            >
              {score}
            </span>
            <span className="font-mono text-neutral-500 text-lg">/100</span>
            <span
              className={`ml-3 border ${tone.border} ${tone.fg} font-mono text-xs uppercase tracking-widest px-2 py-0.5`}
            >
              {tone.label}
            </span>
          </div>
          <div className="mt-4 h-1.5 w-56 bg-neutral-200">
            <div
              className="h-full bg-neutral-900 ma-trans"
              style={{ width: `${score}%` }}
            />
          </div>
        </div>

        <div className="grid grid-cols-4 gap-0 border border-neutral-900">
          <Stat label={t(lang, "stats_critical")} value={stats.critical || 0} tone="text-red-700" testid="stat-critical" />
          <Stat label={t(lang, "stats_warning")} value={stats.warning || 0} tone="text-amber-700" testid="stat-warning" />
          <Stat label={t(lang, "stats_info")} value={stats.info || 0} tone="text-blue-700" testid="stat-info" />
          <Stat label={t(lang, "stats_total")} value={stats.total || 0} tone="text-neutral-900" testid="stat-total" last />
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, tone, testid, last }) {
  return (
    <div
      className={`px-4 py-3 bg-white ${last ? "" : "border-r border-neutral-900"} min-w-[84px]`}
      data-testid={testid}
    >
      <div className="text-[9px] uppercase tracking-[0.2em] font-mono text-neutral-500">
        {label}
      </div>
      <div className={`font-display text-2xl font-semibold ${tone}`}>{value}</div>
    </div>
  );
}
